import loggerService from '../../utils/loggerService';

app.service('execCommandService', [
  '$q',
  function ($q) {
    return {
      copyToClipboard: function (copyText) {
        if (!copyText) {
          return $q.resolve();
        }

        return $q
          .resolve(navigator.clipboard.writeText(copyText))
          .catch(function (err) {
            loggerService.warn(err);
          });
      },
    };
  },
]);
